import {FETCH_LEGENDCATEGORIES_REQUEST,FETCH_LEGENDCATEGORIES_SUCCESS, FETCH_LEGENDCATEGORIES_FAILURE} from "./legendCategoryTypes";

const initialState = {
  loading: true,
  data: [],
  errorMsg: "",
};

const legendCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LEGENDCATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_LEGENDCATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        errorMsg: "",
      };
    case FETCH_LEGENDCATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default legendCategoryReducer;
